import React from "react";
import SubmitEmployerId from "../../../../../Diathrive/src/containers/SubmitEmployerId";

const SubmitUniqueId = (props) => <SubmitEmployerId {...props} />;

export default SubmitUniqueId;
